import { useContext } from "react";

import darkFallback from "shared/assets/images/large_dark_fallback.jpg";
import lightFallback from "shared/assets/images/large_light_fallback.jpg";
import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import GlobalContext from "shared/providers/context/GlobalContext";
import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";
import SpecialOffersOrderBump from "@payment/components/molecules/SpecialOffersOrderBump";
import { getDateToPaySubscription } from "@payment/utils/getDateToPaySubscription";

import {
  ContainerDetailsProduct,
  ContentDetailsProduct,
  Image,
  Paragraph,
  PriceContainer,
  ProductTitle,
  Strong,
  SubscritionWarning,
  SubscritionWarningStrong,
  WrapperMainProduct,
} from "./styles";

const MainContentOrderBump = ({ textForInstallmentAmountVisualization }) => {
  const {
    offer,
    installments,
    orderBumpsSelected,
    methodPaymentSelected,
    orderBumpsInstallmentSelected,
  } = useCheckoutStepsOffersContext();

  const { state } = useContext(GlobalContext);
  const isDarkMode = state.theme.value === "dark";
  const emptyImage = isDarkMode ? darkFallback : lightFallback;
  const paymentType = offer?.offer?.details?.payment_type;

  const isEnablePaymentCreditCard =
    offer?.offer?.details?.payment_methods?.credit_card;

  const months = {
    monthly: "todo mês",
    quarterly: "a cada 3 meses",
    semiannual: "a cada 6 meses",
    annual: "a cada 12 meses",
  };

  const acquirer = state?.tenancy?.acquirer;
  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0]?.value < acquirer?.min_value;

  const dateToPaySubscription = getDateToPaySubscription(
    offer?.offer?.details?.trial_enabled,
    offer?.offer?.details?.trial_days,
  );

  return (
    <WrapperMainProduct>
      <ContainerDetailsProduct>
        <Image src={offer?.group?.logo_horizontal || emptyImage?.src} />

        <ContentDetailsProduct>
          <ProductTitle>{offer?.group?.title}</ProductTitle>
          {!isEnablePaymentCreditCard ? (
            <Strong>{formatBrazilianCurrency(installments[0]?.value)}</Strong>
          ) : !IS_MIN_VALUE ? (
            offer?.offer?.details?.amount_visualization === "full" ||
            !offer?.installments ? (
              <PriceContainer>
                <Strong>
                  {formatBrazilianCurrency(installments[0]?.value)}
                </Strong>

                {offer?.installments && (
                  <Paragraph>{textForInstallmentAmountVisualization}</Paragraph>
                )}
              </PriceContainer>
            ) : (
              <PriceContainer>
                <Strong>{textForInstallmentAmountVisualization}</Strong>
                <Paragraph>
                  ou {formatBrazilianCurrency(installments[0]?.value)} à vista
                </Paragraph>
              </PriceContainer>
            )
          ) : (
            <PriceContainer>
              <Strong>
                {formatBrazilianCurrency(Number(offer.offer.price))}
              </Strong>
            </PriceContainer>
          )}
        </ContentDetailsProduct>
      </ContainerDetailsProduct>

      {paymentType !== "unique" && (
        <SubscritionWarning>
          O pagamento da sua assinatura será cobrado{" "}
          <SubscritionWarningStrong>
            {months[offer?.offer?.frequency]}
          </SubscritionWarningStrong>{" "}
          no{" "}
          <SubscritionWarningStrong>
            dia {dateToPaySubscription}.
          </SubscritionWarningStrong>
        </SubscritionWarning>
      )}

      <ComponentErrorBoundary>
        <SpecialOffersOrderBump
          orderBumpsSelected={orderBumpsSelected}
          methodPaymentSelected={methodPaymentSelected}
          orderBumpsInstallmentSelected={orderBumpsInstallmentSelected}
        />
      </ComponentErrorBoundary>
    </WrapperMainProduct>
  );
};

export default MainContentOrderBump;
